import { createContext, useState, useContext, useEffect } from 'react';
import { post, get } from '../controllers/apiController';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem('token');
      if (storedToken && !user) {
        try {
          const userData = await get("users/me");
          setUser(userData);
        } catch (error) {
          console.error('Kullanıcı bilgileri alınamadı:', error);
          localStorage.removeItem('token');
          setToken(null);
        }
      }
      setIsLoading(false);
    };

    initAuth();
  }, []); // Sadece component mount olduğunda çalışsın

  const login = async (email, password) => {
    try {
      const response = await post("auth/login", { email, password });
      
      if (response.token) {
        localStorage.setItem('token', response.token);
        setToken(response.token);
        
        // Kullanıcı bilgilerini al
        const userData = await get("users/me");
        setUser(userData);
        
        return { success: true };
      }
      return { success: false, message: 'Geçersiz yanıt' };
    } catch (error) {
      return { success: false, message: error.response.data.message || 'Giriş başarısız' };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  if (isLoading) {
    return null; // veya loading spinner
  }

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);